import React, { useState } from 'react';
import { playStoreUrl } from '../lib/appLinks';

interface MobileStickyCtaProps {
  onStartAiInterpretation: () => void;
}

const STORAGE_KEY = 'ibn-sirin-sticky-cta-dismissed';

const MobileStickyCta: React.FC<MobileStickyCtaProps> = ({ onStartAiInterpretation }) => {
  const [dismissed, setDismissed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  });

  if (dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-40 md:hidden" dir="rtl">
      <div className="bg-slate-900/95 backdrop-blur-md border-t border-slate-700/80 px-3 py-2.5 flex items-center gap-2 shadow-[0_-8px_24px_rgba(0,0,0,0.35)]">
        <button
          onClick={() => onStartAiInterpretation()}
          className="flex-1 py-2.5 px-3 bg-gradient-to-r from-emerald-600 to-teal-600 active:from-emerald-500 active:to-teal-500 text-white font-bold text-sm rounded-xl transition-all active:scale-95 text-center"
        >
          🔮 فسّر حلمك بالـAI
        </button>
        <a
          href={playStoreUrl('mobile_sticky')}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 py-2.5 px-3 bg-slate-800 border border-slate-600 text-emerald-300 font-bold text-sm rounded-xl transition-all active:scale-95 text-center no-underline"
        >
          📱 افتح التطبيق
        </a>
        <button
          onClick={handleDismiss}
          aria-label="إخفاء الشريط"
          className="shrink-0 w-9 h-9 flex items-center justify-center text-slate-400 hover:text-white bg-slate-800 rounded-xl border border-slate-700 transition-colors"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default MobileStickyCta;